(function(angular) {
    'use strict';
    angular.module('GorillaBoy.OfficeEditor');
}(angular));